import { updateQuery } from '../page/location';
import { QUERY_SELECTED_TARIFF } from '../../helpers/constants';


export const selectTariff = (location, { eid } = {}) => (
  updateQuery(location, {
    [QUERY_SELECTED_TARIFF]: eid,
  })
);
